<template>
  <div>
    <v-dialog v-model="modal" lazy max-width="600px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{$t('inscription')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="$emit('update:modal', false)" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md text-xs-left>
          <v-card-text>
            <v-flex xs12>
              <v-autocomplete
                v-if="tournament.type==='teams' || tournament.type==='usersTeams'"
                :items="listTeams.filter(item => !participantList.some(p =>p.teamId == item.value))"
                :label="$t('select', {field: $tc('team')})"
                v-model="participant.teamId"
                @change="userIds = []"
              ></v-autocomplete>
              <v-autocomplete
                v-if="tournament.type==='users' "
                :items="listUsers.filter(item => item.roles.includes('participant') && !participantList.some(p =>p.userId == item.value))"
                :label="$t('select', {field: $tc('user')})"
                v-model="participant.userId"
              ></v-autocomplete>
              <v-autocomplete
                v-if="tournament.type==='usersTeams' "
                :items="users"
                :label="$t('select', {field: $tc('user',2)})"
                multiple
                :disabled="!participant.teamId"
                v-model="userIds"
                @change="searchUser = ''"
                :search-input.sync="searchUser"
              ></v-autocomplete>
            </v-flex>
          </v-card-text>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('update:modal', false)" color="primary" small>{{$t('cancel')}}</v-btn>
          <v-btn @click="setParticipant()" color="success" small>
            <span v-if="loading">
              <v-progress-circular :size="20" :width="3" color="#FFFFFF" indeterminate></v-progress-circular>
            </span>
            <span v-else>{{$t('save')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import queueToast from '@/helpers/queueToast'
export default {
  name: 'DialogInscription',
  props: {
    modal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      participant: {},
      searchUser: '',
      userIds: []
    }
  },
  watch: {
    modal(val) {
      if (!val) this.$emit('update:modal', false)
    }
  },
  mounted() {
    this.participant = Object.assign({}, this.templateParticipant())
  },
  computed: {
    ...mapState({
      tournament: state => state.tournaments.selected,
      listTeams: state => state.teams.listSelectTeams,
      listUsers: state => state.users.listSelectUsers
    }),
    participantList() {
      if (!this.tournament) return []
      if (this.tournament.type === 'teams') {
        return this.tournament.teams
      } else if (this.tournament.type === 'users') {
        return this.tournament.users
      } else return []
    },
    users() {
      if (!this.tournament || !this.tournament.users) return []
      let users = this.listUsers.filter(
        item =>
          item.roles.includes('participant') &&
          !this.tournament.users.some(p => p.userId == item.value)
      )

      return users.filter(item =>
        item.teamIds.includes(this.participant.teamId)
      )
    }
  },
  methods: {
    ...mapActions({
      setUpdate: 'tournaments/setUpdate'
    }),
    templateParticipant: () => {
      return {
        userId: '',
        teamId: '',
        confirmed: true,
        accepted: false,
        invitationSent: false
      }
    },
    isValidParticipant() {
      let error = false
      let messages = []
      if (this.tournament.type === 'teams') {
        if (!this.participant.teamId) {
          error = true
          messages.push(this.$t('error.required', { field: this.$tc('team') }))
        }
      }
      if (this.tournament.type === 'users') {
        if (!this.participant.userId) {
          error = true
          messages.push(this.$t('error.required', { field: this.$tc('user') }))
        }
      }
      if (this.tournament.type === 'usersTeams') {
        if (!this.participant.teamId) {
          error = true
          messages.push(this.$t('error.required', { field: this.$tc('team') }))
        }
        if (!this.userIds.length) {
          error = true
          messages.push(
            this.$t('error.required', { field: this.$tc('user', 2) })
          )
        }
      }
      if (error) {
        queueToast(messages)
        return false
      }
      return true
    },
    setParticipant() {
      if (!this.isValidParticipant() || this.loading) return
      let payload = { _id: this.tournament._id }
      let participant = { ...this.participant }

      if (this.tournament.type === 'teams') {
        delete participant.userId
        payload.teams = this.tournament.teams.slice()
        payload.teams.push(participant)
      } else if (this.tournament.type === 'users') {
        delete participant.teamId
        payload.users = this.tournament.users.slice()
        payload.users.push(participant)
      } else if (this.tournament.type === 'usersTeams') {
        participant.userIds = []
        delete participant.userId
        payload.teams = this.tournament.teams.slice()
        payload.users = this.tournament.users.slice()

        this.userIds.forEach(userId => {
          if (payload.users.some(item => item.userId == userId)) return
          let user = this.templateParticipant()
          delete user.teamId
          user.userId = userId
          payload.users.push(user)
          participant.userIds.push(userId)
        })
        payload.teams.push(participant)
      }
      payload.inscription = true
      this.loading = true
      this.setUpdate(payload)
        .then(() => {
          this.participant = Object.assign({}, this.templateParticipant())
          this.$emit('update:modal', false)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
